import React, { useState, useEffect } from 'react';
import assetUrl from '../../utils/assetUrl';

const EveHero = () => {
  const [reflight, setReflight] = useState(0);
  const [pounds, setPounds] = useState(0);
  const [thrust, setThrust] = useState(0);

  useEffect(() => {
    const duration = 2000; 
    const targets = { reflight: 400, pounds: 1500, thrust: 12 };
    const startTime = Date.now();

    const easeOutCubic = (progress) => {
      
      return 1 - Math.pow(1 - progress, 3);
    };

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const rawProgress = Math.min(elapsed / duration, 1);
      const progress = easeOutCubic(rawProgress);

      setReflight(Math.round(targets.reflight * progress));
      setPounds(Math.round(targets.pounds * progress));
      setThrust(Math.round(targets.thrust * progress));

      if (rawProgress < 1) {
        requestAnimationFrame(animate);
      } else {
        
        setReflight(targets.reflight);
        setPounds(targets.pounds);
        setThrust(targets.thrust);
      }
    };

    requestAnimationFrame(animate);
  }, []);
  return (
    <section className="eve-hero" style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: '#fff',
      textAlign: 'center',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {}
      <div className="eve-hero-content" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `url(${assetUrl('EVE WHT.png')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: -1
      }}></div>

      {}
      <div style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: '10%',
        background: 'linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1))',
        pointerEvents: 'none',
        zIndex: 2
      }} />

      <div style={{
        position: 'relative',
        zIndex: 10,
        height: '100%',
        width: '100%',
        maxWidth: '1500px'
      }}>
        {}
        <h1 className="eve-hero-title" style={{
          position: 'absolute',
          top: 'calc(50% - 30px)',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: 'clamp(3rem, 10vw, 6rem)',
          margin: '0',
          fontWeight: '300',
          letterSpacing: '0.1em',
          textShadow: '0 0 20px rgba(255,255,255,0.5)',
          textAlign: 'center'
        }}>EVE</h1>

        {}
        <p className="eve-hero-subtitle" style={{
          position: 'absolute',
          top: 'calc(56vh - 30px)',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: 'clamp(1rem, 3vw, 1.5rem)',
          margin: '0',
          fontWeight: '300',
          opacity: 0.9,
          textShadow: '0 0 10px rgba(255,255,255,0.3)',
          textAlign: 'center'
        }}>
          THE WORLDS FIRST ORBITAL-CLASS LAUNCH VEHICLE DESIGNED TO OPERATIONALIZE MAGNETOHYDRODYNAMIC REENTRY
        </p>

        {}
        <div className="eve-hero-stats" style={{
          position: 'absolute',
          bottom: 'calc(6vh + 30px)',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          justifyContent: 'center',
          gap: '60px',
          flexWrap: 'wrap'
        }}>
          <div className="eve-hero-stat" style={{ textAlign: 'center' }}>
            <h2 className="eve-hero-stat-value" style={{ fontSize: '3rem', margin: '0', fontWeight: '700', color: '#fff' }}>{reflight}</h2>
            <p className="eve-hero-stat-label" style={{ fontSize: '0.9rem', opacity: 0.7, margin: '5px 0 0 0' }}>REFLIGHT CYCLES</p>
          </div>
          <div className="eve-hero-stat" style={{ textAlign: 'center' }}>
            <h2 className="eve-hero-stat-value" style={{ fontSize: '3rem', margin: '0', fontWeight: '700', color: '#fff' }}>{pounds}</h2>
            <p className="eve-hero-stat-label" style={{ fontSize: '0.9rem', opacity: 0.7, margin: '5px 0 0 0' }}>KILOGRAMS TO LEO</p>
          </div>
          <div className="eve-hero-stat" style={{ textAlign: 'center' }}>
            <h2 className="eve-hero-stat-value" style={{ fontSize: '3rem', margin: '0', fontWeight: '700', color: '#fff' }}>{thrust}</h2>
            <p className="eve-hero-stat-label" style={{ fontSize: '0.9rem', opacity: 0.7, margin: '5px 0 0 0' }}>AURORA ENGINES</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EveHero;